// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { ImageCommonFragmentDoc } from './imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from './imageSize.fragment.generated';
export const ImageLargeFragmentDoc = `
    fragment imageLarge on Image {
  ...imageCommon
  size: size(name: LARGE) {
    ...imageSize
  }
  size_x2: size(name: LARGE_X2) {
    ...imageSize
  }
}
    `;